<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-align-center inset-0 !flex">
        <div
            class="flex-column flex h-auto w-full rounded-2xl bg-white dark:border-2 dark:border-solid dark:border-contrast-yellow">
            <div class="flex-align-center !flex justify-between border-solid p-4">
                <div class="flex-align-center flex w-6">
                    <div
                        class="icon icon-arrow-left"
                        *ngIf="selectedModalStep === ModalStep.code"
                        (click)="handleBackClicked()"></div>
                </div>
                <p class="font-semibold">
                    {{
                        (selectedModalStep === ModalStep.phoneNumber
                            ? 'ENTER_YOUR_PHONE_NUMBER_LABEL'
                            : 'ENTER_ONE_TIME_PASSWORD_LABEL'
                        ) | translate
                    }}
                </p>
                <button class="pt-2" [attr.aria-label]="'CLOSE' | translate" (click)="closeModal()" mat-icon-button>
                    <mat-icon class="close-button font-bold">close</mat-icon>
                </button>
            </div>

            <div class="box-border flex-1 overflow-y-auto p-4" *ngIf="selectedModalStep === ModalStep.phoneNumber">
                <p class="mb-8">
                    {{ 'ENTER_YOUR_PHONE_DESCRIPTION' | translate }}
                </p>

                <div class="flex flex-1 justify-between gap-2">
                    <div
                        class="flex-align-center w-25 flex h-14 justify-between rounded-lg border border-solid bg-white p-4 font-bold dark:bg-contrast-black"
                        (click)="handleSelectCountryClick()">
                        <p>{{ selectedCode }}</p>
                        <mat-icon class="arrow-drop-down material-icons-round">arrow_drop_down</mat-icon>
                    </div>
                    <div class="relative flex-1">
                        <p
                            class="vl-app-light:bg-grey-white_smoke sr-app-light:bg-grey-white_smoke absolute ml-2 bg-white px-1 text-xs text-grey-zambezy dark:text-contrast-yellow"
                            [ngClass]="{ 'text-red': !!errorType }">
                            {{ 'PHONE_NUMBER' | translate }}
                        </p>
                        <div
                            class="vl-app-light:bg-grey-white_smoke sr-app-light:bg-grey-white_smoke phone-number flex-align-center mb-1 flex h-14 justify-between rounded-lg border border-solid bg-white px-2 py-1"
                            [ngClass]="{ 'border-red': !!errorType }">
                            <ion-input
                                class="stw-form bottom-1 w-full rounded-lg"
                                [value]="phoneNumber"
                                (change)="numberChange($event)"
                                name="phoneNumber"
                                type="number"
                                inputmode="numeric">
                            </ion-input>
                        </div>
                        <p class="word-break text-red h-4 border-b text-xs">
                            <ng-container *ngIf="errorType">
                                {{ errorType | translate }}
                            </ng-container>
                        </p>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="selectedModalStep === ModalStep.code">
                <div class="box-border flex h-14 flex-1 gap-2 overflow-y-auto p-4">
                    <ng-container *ngFor="let index of [0, 1, 2, 3, 4, 5]">
                        <ion-item
                            class="bg-grey-white_smoke dark:bg-contrast-black dark:text-contrast-yellow"
                            [class]="{ 'errorCodeItem': !!errorType, 'number-input': true }"
                            fill="outline"
                            mode="md">
                            <ion-input
                                class="bottom-1 flex-1 rounded-lg"
                                #codeInputs
                                [value]="enteredCode[index]"
                                (keydown)="onKeyDown($event, index)"
                                (ionChange)="onChange($event)"
                                (paste)="onPaste($event)"
                                type="number"
                                inputmode="numeric">
                            </ion-input>
                        </ion-item>
                    </ng-container>
                </div>
                <p class="word-break error-message mat-error px-4 text-xs" *ngIf="errorType">
                    {{ errorType | translate }}
                </p>
                <mat-divider class="mt-2"></mat-divider>
            </ng-container>
            <div class="m-4 mt-0">
                <ion-button
                    class="mb-2 w-full"
                    *ngIf="selectedModalStep === ModalStep.code"
                    [attr.aria-label]="'RESEND_CODE' | translate"
                    (click)="handleResendPasswordClicked()"
                    size="large"
                    fill="clear">
                    <ion-label class="text-base normal-case">
                        {{ 'RESEND_CODE' | translate }}
                    </ion-label>
                </ion-button>

                <button
                    class="sr-app-light:text-white modal-confirm-button h-14 w-full rounded-lg font-bold text-contrast-black dark:bg-contrast-yellow dark:text-contrast-black"
                    [disabled]="isRequestSending"
                    (click)="handleNextClick()">
                    {{
                        (selectedModalStep === ModalStep.phoneNumber
                            ? 'REQUEST_ONE_TIME_PASSWORD_LABEL'
                            : 'ENTER_ONE_TIME_PASSWORD_LABEL'
                        ) | translate
                    }}
                </button>
            </div>
        </div>
    </div>
</div>
